<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Exam Alert' : 'Add Exam Alert'"
>
</nz-page-header>

<form nz-form [formGroup]="addUpdateJobAlertForm">
  <!-- ─── Autocomplete sources (declared once at form root, reachable from every nested row) ─── -->
  <nz-autocomplete #stageAttrAuto>
    <nz-auto-option
      *ngFor="let opt of suggestedStageAttributes"
      [nzValue]="opt"
      >{{ opt }}</nz-auto-option
    >
  </nz-autocomplete>
  <nz-autocomplete #subjectAttrAuto>
    <nz-auto-option
      *ngFor="let opt of suggestedSubjectAttributes"
      [nzValue]="opt"
      >{{ opt }}</nz-auto-option
    >
  </nz-autocomplete>

  <!-- ─── SECTION 1: Basic Info ─── -->
  <nz-card
    nzTitle="Basic Information"
    nz-col
    nzLg="24"
    nzMd="24"
    nzSm="24"
    nzXs="24"
    style="margin-bottom: 16px"
  >
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <!-- Title -->
      <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Title</nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="Title is required">
            <input
              nz-input
              formControlName="title"
              type="text"
              placeholder="e.g. SSC CGL 2024"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Job Category -->
      <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Exam Category</nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="Exam Category is required">
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Category"
              formControlName="jobCategory"
              (nzOnSearch)="onExamCategorySearch($event)"
              (nzScrollToBottom)="loadMoreCategories()"
            >
              <nz-option
                *ngFor="let cat of listOfCategories"
                [nzLabel]="cat.categoryName"
                [nzValue]="cat._id"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Job Type -->
      <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Exam Type</nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="Exam Type is required">
            <nz-select
              nzPlaceHolder="Select Exam Type"
              formControlName="jobType"
            >
              <nz-option
                *ngFor="let type of jobTypes"
                [nzLabel]="type"
                [nzValue]="type"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- State -->
      <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>State</nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="State is required">
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select State"
              formControlName="state"
              [nzLoading]="statesLoading"
            >
              <nz-option
                *ngFor="let s of listOfStates; let i = index"
                [nzLabel]="s.name"
                [nzValue]="s.name"
                [nzDisabled]="i === 1"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Published Status -->
      <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Published Status</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group formControlName="publishedStatus">
              <label nz-radio nzValue="published">
                <span>Published</span>
              </label>
              <label nz-radio nzValue="unpublished">
                <span>Unpublished</span>
              </label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Total Vacancy -->
      <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Total Vacancy</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-number
              style="width: 100%"
              formControlName="totalVacancy"
              [nzMin]="1"
              nzPlaceHolder="e.g. 500"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Salary -->
      <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Salary</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input
              nz-input
              formControlName="salary"
              type="text"
              placeholder="e.g. ₹25,500 - ₹1,51,100"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Qualification -->
      <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Qualification</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select
              nzMode="tags"
              nzPlaceHolder="Add qualifications"
              formControlName="qualification"
            ></nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="20" nzMd="20" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Description</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <ngx-suneditor
              [options]="editorOptions"
              [editorID]="'description'"
              (onChange)="onDescriptionChange($event)"
            ></ngx-suneditor>
          </nz-form-control>
        </nz-form-item>
      </div>
      <!-- Image (moved here from Section 5) -->
      <div nz-col nzLg="4" nzMd="4" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Image</nz-form-label>

          <nz-upload
            class="upload-list-inline"
            [nzName]="'file'"
            [nzShowUploadList]="false"
            [nzBeforeUpload]="beforeMediaUpload"
            [nzAction]="mediaUploadUrl"
            [nzHeaders]="customRequestHeaders"
            (nzChange)="uploadImageFile($event, 'image')"
          >
            <button nz-button *ngIf="!imageMeta" [nzLoading]="imageLoading">
              <span nz-icon nzType="upload"></span> Upload
            </button>
          </nz-upload>

          <div *ngIf="imageMeta" class="image-preview-card">
            <div class="image-preview-wrapper">
              <img
                nz-image
                class="image-preview-img"
                [nzSrc]="mediaBaseUrl + imageMeta.path"
              />
            </div>

            <div class="image-action-row">
              <a
                nz-button
                nzType="text"
                nzTooltipTitle="Download"
                nz-tooltip
                [href]="mediaBaseUrl + imageMeta.path"
                target="_blank"
                download
                class="image-action-btn image-action-download"
              >
                <span nz-icon nzType="download"></span>
              </a>

              <button
                nz-button
                nzType="text"
                nzDanger
                nzTooltipTitle="Delete"
                nz-tooltip
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete this image?"
                (nzOnConfirm)="removeImage('image')"
                class="image-action-btn image-action-delete"
              >
                <span nz-icon nzType="delete"></span>
              </button>
            </div>
          </div>
        </nz-form-item>
      </div>
    </div>
  </nz-card>

  <!-- ─── SECTION 2: Age Limit & Dates ─── -->
  <nz-card
    nzTitle="Age Limit & Important Dates"
    nz-col
    nzLg="24"
    nzMd="24"
    nzSm="24"
    nzXs="24"
    style="margin-bottom: 16px"
  >
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <div nz-col nzLg="6" nzMd="6" nzSm="12" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Min Age</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-number
              style="width: 100%"
              formControlName="ageLimitMin"
              [nzMin]="1"
              nzPlaceHolder="18"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzLg="6" nzMd="6" nzSm="12" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Max Age</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-number
              style="width: 100%"
              formControlName="ageLimitMax"
              [nzMin]="1"
              nzPlaceHolder="35"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzLg="6" nzMd="6" nzSm="12" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Apply Start Date</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker
              style="width: 100%"
              formControlName="applyStartDate"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzLg="6" nzMd="6" nzSm="12" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Apply End Date</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker
              style="width: 100%"
              formControlName="applyEndDate"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </nz-card>

  <!-- ─── SECTION 2.5: Important Dates ─── -->
  <nz-card
    nzTitle="Important Dates"
    nz-col
    nzLg="24"
    nzMd="24"
    nzSm="24"
    nzXs="24"
    style="margin-bottom: 16px"
  >
    <div formArrayName="importantDates">
      <div
        *ngFor="let dateItem of importantDatesArray.controls; let k = index"
        [formGroupName]="k"
      >
        <div
          nz-row
          [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
          style="align-items: center"
        >
          <div nz-col nzLg="11" nzMd="11" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Title</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  formControlName="title"
                  placeholder="e.g. Admit Card Date"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="11" nzMd="11" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Date / Value</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  formControlName="value"
                  placeholder="e.g. TBA or 25 Aug 2024"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="2" nzMd="2" nzSm="24" nzXs="24">
            <button
              nz-button
              nzDanger
              nzSize="small"
              (click)="removeImportantDate(k)"
            >
              <span nz-icon nzType="minus-circle"></span> Remove
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
      nz-button
      nzType="dashed"
      style="width: 100%; margin-top: 8px"
      (click)="addImportantDate()"
    >
      <span nz-icon nzType="plus"></span> Add More Dates
    </button>
  </nz-card>

  <!-- ─── SECTION 3: Application Fee ─── -->
  <nz-card
    nzTitle="Application Fee (₹)"
    nz-col
    nzLg="24"
    nzMd="24"
    nzSm="24"
    nzXs="24"
    style="margin-bottom: 16px"
  >
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <div
        nz-col
        nzLg="4"
        nzMd="7"
        nzSm="12"
        nzXs="24"
        *ngFor="let cat of feeCategories"
      >
        <nz-form-item>
          <nz-form-label [nzSpan]="24">{{ cat.label }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input
              nz-input
              [formControlName]="cat.control"
              placeholder="e.g. 0 or Free"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </nz-card>

  <!-- ─── SECTION 4: Exam Stages ─── -->
  <nz-card
    nzTitle="Exam Stages"
    nz-col
    nzLg="24"
    nzMd="24"
    nzSm="24"
    nzXs="24"
    style="margin-bottom: 16px"
  >
    <div formArrayName="examStages">
      <nz-card
        *ngFor="let stage of examStagesArray.controls; let i = index"
        [formGroupName]="i"
        [nzTitle]="'Stage ' + (i + 1)"
        [nzExtra]="stageExtra"
        style="margin-bottom: 12px"
        nzSize="small"
      >
        <ng-template #stageExtra>
          <button
            nz-button
            nzDanger
            nzSize="small"
            nz-popconfirm
            nzPopconfirmTitle="Remove this stage?"
            (nzOnConfirm)="removeStage(i)"
          >
            <span nz-icon nzType="delete"></span> Remove
          </button>
        </ng-template>

        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <div nz-col nzLg="4" nzMd="4" nzSm="12" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Order</nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Required">
                <nz-input-number
                  style="width: 100%"
                  formControlName="stageOrder"
                  [nzMin]="1"
                ></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzLg="4" nzMd="4" nzSm="12" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Stage Name</nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Required">
                <input
                  nz-input
                  formControlName="stageName"
                  placeholder="e.g. Mains"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzLg="4" nzMd="4" nzSm="12" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Exam Date</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-date-picker
                  style="width: 100%"
                  formControlName="examDate"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzLg="4" nzMd="4" nzSm="12" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Total Marks</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-number
                  style="width: 100%"
                  formControlName="totalMarks"
                  [nzMin]="0"
                ></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col nzLg="4" nzMd="4" nzSm="12" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Total Questions</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-number
                  style="width: 100%"
                  formControlName="totalQuestions"
                  [nzMin]="0"
                ></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="4" nzMd="4" nzSm="12" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24"
                >Total Duration (in min)</nz-form-label
              >
              <nz-form-control [nzSpan]="24">
                <nz-input-number
                  style="width: 100%"
                  formControlName="totalDurations"
                  [nzMin]="0"
                ></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- Instructions (rich text editor) -->
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Instructions</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <ngx-suneditor
                  [options]="editorOptions"
                  [editorID]="'instructions-' + i"
                  (onChange)="onInstructionsChange($event, i)"
                ></ngx-suneditor>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- Stage Attributes -->
        <nz-divider
          nzPlain
          nzText="Attributes"
          nzOrientation="left"
        ></nz-divider>
        <div formArrayName="attributes">
          <div
            *ngFor="
              let attr of getStageAttributesArray(i).controls;
              let a = index
            "
            [formGroupName]="a"
          >
            <div
              nz-row
              [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
              style="align-items: center"
            >
              <!-- Type -->
              <div nz-col nzLg="3" nzMd="3" nzSm="24" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Type</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="type" nzPlaceHolder="Type" (ngModelChange)="onStageAttrTypeChange($event, i, a)">
                      <nz-option
                        *ngFor="let t of attributeTypes"
                        [nzLabel]="t | titlecase"
                        [nzValue]="t"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <!-- Key -->
              <div nz-col nzLg="8" nzMd="8" nzSm="12" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Name</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input
                      nz-input
                      formControlName="key"
                      placeholder="e.g. Mode"
                      [nzAutocomplete]="stageAttrAuto"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <!-- Value (conditional on type) -->
              <div nz-col nzLg="9" nzMd="9" nzSm="12" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Value</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <ng-container [ngSwitch]="attr.get('type')?.value">
                      <ng-container *ngSwitchCase="'textarea'">
                        <ngx-suneditor
                          *ngIf="attrEditorReady"
                          [options]="editorOptions"
                          [editorID]="'stage-attr-' + i + '-' + a"
                          (onChange)="onStageAttrValueChange($event, i, a)"
                        ></ngx-suneditor>
                      </ng-container>
                      <nz-input-number
                        *ngSwitchCase="'number'"
                        style="width: 100%"
                        formControlName="value"
                        nzPlaceHolder="e.g. 100"
                      ></nz-input-number>
                      <nz-date-picker
                        *ngSwitchCase="'date'"
                        style="width: 100%"
                        formControlName="value"
                      ></nz-date-picker>
                      <input
                        *ngSwitchDefault
                        nz-input
                        formControlName="value"
                        [placeholder]="
                          attr.get('type')?.value === 'link'
                            ? 'https://...'
                            : 'e.g. Online'
                        "
                      />
                    </ng-container>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div
                nz-col
                nzLg="3"
                nzMd="3"
                nzSm="24"
                nzXs="24"
                style="padding-top: 28px"
              >
                <button
                  nz-button
                  nzDanger
                  nzSize="small"
                  (click)="removeStageAttribute(i, a)"
                >
                  <span nz-icon nzType="minus-circle"></span> Remove
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          nz-button
          nzType="dashed"
          nzSize="small"
          (click)="addStageAttribute(i)"
        >
          <span nz-icon nzType="plus"></span> Add Attribute
        </button>

        <!-- Subjects -->
        <nz-divider nzPlain nzText="Subjects" nzOrientation="left"></nz-divider>
        <div formArrayName="subjects">
          <div
            *ngFor="let subject of getSubjectsArray(i).controls; let j = index"
            [formGroupName]="j"
          >
            <div
              nz-row
              [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
              style="align-items: center"
            >
              <div nz-col nzLg="10" nzMd="10" nzSm="24" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Subject Name</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input
                      nz-input
                      formControlName="name"
                      placeholder="e.g. General Awareness"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzLg="5" nzMd="5" nzSm="12" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Questions</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-input-number
                      style="width: 100%"
                      formControlName="questions"
                      [nzMin]="0"
                    ></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzLg="5" nzMd="5" nzSm="12" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Marks</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-input-number
                      style="width: 100%"
                      formControlName="marks"
                      [nzMin]="0"
                    ></nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div
                nz-col
                nzLg="3"
                nzMd="3"
                nzSm="24"
                nzXs="24"
                style="padding-top: 28px"
              >
                <button
                  nz-button
                  nzDanger
                  nzSize="small"
                  (click)="removeSubject(i, j)"
                >
                  <span nz-icon nzType="minus-circle"></span> Remove
                </button>
              </div>
            </div>

            <!-- Subject Attributes -->
            <div formArrayName="attributes" style="margin-left: 8px">
              <div
                *ngFor="
                  let sattr of getSubjectAttributesArray(i, j).controls;
                  let b = index
                "
                [formGroupName]="b"
              >
                <div
                  nz-row
                  [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
                  style="align-items: center"
                >
                  <!-- Type -->
                  <div nz-col nzLg="3" nzMd="3" nzSm="24" nzXs="24">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">Type</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select formControlName="type" nzPlaceHolder="Type" (ngModelChange)="onSubjectAttrTypeChange($event, i, j, b)">
                          <nz-option
                            *ngFor="let t of attributeTypes"
                            [nzLabel]="t | titlecase"
                            [nzValue]="t"
                          ></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <!-- Key -->
                  <div nz-col nzLg="8" nzMd="8" nzSm="12" nzXs="24">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">Attr Name</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <input
                          nz-input
                          formControlName="key"
                          placeholder="e.g. Difficulty"
                          [nzAutocomplete]="subjectAttrAuto"
                        />
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <!-- Value (conditional on type) -->
                  <div nz-col nzLg="9" nzMd="9" nzSm="12" nzXs="24">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">Attr Value</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <ng-container [ngSwitch]="sattr.get('type')?.value">
                          <ng-container *ngSwitchCase="'textarea'">
                            <ngx-suneditor
                              *ngIf="attrEditorReady"
                              [options]="editorOptions"
                              [editorID]="
                                'subject-attr-' + i + '-' + j + '-' + b
                              "
                              (onChange)="
                                onSubjectAttrValueChange($event, i, j, b)
                              "
                            ></ngx-suneditor>
                          </ng-container>
                          <nz-input-number
                            *ngSwitchCase="'number'"
                            style="width: 100%"
                            formControlName="value"
                            nzPlaceHolder="e.g. 100"
                          ></nz-input-number>
                          <nz-date-picker
                            *ngSwitchCase="'date'"
                            style="width: 100%"
                            formControlName="value"
                          ></nz-date-picker>
                          <input
                            *ngSwitchDefault
                            nz-input
                            formControlName="value"
                            [placeholder]="
                              sattr.get('type')?.value === 'link'
                                ? 'https://...'
                                : 'e.g. Hard'
                            "
                          />
                        </ng-container>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div
                    nz-col
                    nzLg="4"
                    nzMd="4"
                    nzSm="24"
                    nzXs="24"
                    style="padding-top: 28px"
                  >
                    <button
                      nz-button
                      nzDanger
                      nzSize="small"
                      (click)="removeSubjectAttribute(i, j, b)"
                    >
                      <span nz-icon nzType="minus-circle"></span> Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button
              nz-button
              nzType="dashed"
              nzSize="small"
              style="margin-left: 8px; margin-bottom: 8px"
              (click)="addSubjectAttribute(i, j)"
            >
              <span nz-icon nzType="plus"></span> Add Subject Attribute
            </button>

            <nz-divider style="margin: 8px 0"></nz-divider>
          </div>
        </div>
        <button
          nz-button
          nzType="dashed"
          nzSize="small"
          (click)="addSubject(i)"
        >
          <span nz-icon nzType="plus"></span> Add Subject
        </button>
      </nz-card>
    </div>
    <button
      nz-button
      nzType="dashed"
      style="width: 100%; margin-top: 8px"
      (click)="addStage()"
    >
      <span nz-icon nzType="plus"></span> Add Exam Stage
    </button>
  </nz-card>

  <!-- ─── SECTION 6: Important Links ─── -->
  <nz-card
    nzTitle="Important Links"
    nz-col
    nzLg="24"
    nzMd="24"
    nzSm="24"
    nzXs="24"
    style="margin-bottom: 16px"
  >
    <!-- Static quick-links -->
    <div
      nz-row
      [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
      style="margin-bottom: 8px"
    >
      <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Apply Link</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input
              nz-input
              formControlName="applyLink"
              placeholder="https://..."
            />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <!-- Dynamic important links -->
    <div formArrayName="importantLinks">
      <div
        *ngFor="let link of importantLinksArray.controls; let k = index"
        [formGroupName]="k"
      >
        <div
          nz-row
          [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
          style="align-items: center"
        >
          <div nz-col nzLg="11" nzMd="11" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Title</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  formControlName="title"
                  placeholder="e.g. Official Notification"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="11" nzMd="11" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">URL / Value</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  formControlName="value"
                  placeholder="https://..."
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzLg="2" nzMd="2" nzSm="24" nzXs="24">
            <button
              nz-button
              nzDanger
              nzSize="small"
              (click)="removeImportantLink(k)"
            >
              <span nz-icon nzType="minus-circle"></span> Remove
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
      nz-button
      nzType="dashed"
      style="width: 100%; margin-top: 8px"
      (click)="addImportantLink()"
    >
      <span nz-icon nzType="plus"></span> Add More Links
    </button>
  </nz-card>

  <!-- ─── Submit ─── -->
  <div nz-row nzJustify="end" style="margin-bottom: 24px">
    <button
      nz-button
      nzType="primary"
      [nzLoading]="buttonLoading"
      [disabled]="buttonLoading"
      (click)="submit()"
      class="submitoraddbutton"
    >
      {{ idForUpdate ? "Update" : "Submit" }}
    </button>
  </div>
</form>
